import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import RouteStatusPage from './RouteStatusPage';

const AccessDenied: FC = () => {
    const { t } = useTranslation();

    return <RouteStatusPage title={t('auth.accessDenied')} message={t('auth.noPageAccess')} />;
};

export default AccessDenied;
